import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/sources/edge-gateways/$id/overview")({
  staticData: {
    title: "edge.navigation.overview",
  },
});
